import React, { useEffect, useState } from 'react';
import { FiZap, FiCheckCircle, FiClock } from 'react-icons/fi';
import { useApi } from '../hooks/useApi';
import p from './Pages.module.css';

export default function Dashboard() {
  const api = useApi();
  const [stats, setStats] = useState({ total: null, finished: null, pending: null });

  useEffect(() => {
    api.get('/v1/clasico/stats').then(setStats).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pending = stats.pending != null
    ? stats.pending
    : (stats.total != null && stats.finished != null)
      ? stats.total - stats.finished
      : null;

  return (
    <div className={p.page}>
      <div className={p.pageHeader}>
        <h1 className={p.pageTitle}>Dashboard</h1>
        <p className={p.pageSubtitle}>Welcome to Clasico Analytics — your betting intelligence hub</p>
      </div>

      <div className={p.statsGrid}>
        <div className={p.statCard}>
          <span className={p.statIcon}><FiZap style={{ color: 'var(--accent)' }} /></span>
          <div className={p.statValue}>{stats.total ?? '—'}</div>
          <div className={p.statLabel}>Total Matches</div>
          <div className={`${p.statBar} ${p.statBarTotal}`} />
        </div>

        <div className={p.statCard}>
          <span className={p.statIcon}><FiCheckCircle style={{ color: '#73c991' }} /></span>
          <div className={p.statValue}>{stats.finished ?? '—'}</div>
          <div className={p.statLabel}>Settled</div>
          <div className={`${p.statBar} ${p.statBarFinished}`} />
        </div>

        <div className={p.statCard}>
          <span className={p.statIcon}><FiClock style={{ color: '#d4a052' }} /></span>
          <div className={p.statValue}>{pending ?? '—'}</div>
          <div className={p.statLabel}>Pending</div>
          <div className={`${p.statBar} ${p.statBarPending}`} />
        </div>
      </div>
    </div>
  );
}

